import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";

export const ReusoProcesoSchema = yup.object().shape({
  volumenTanque: CantidadSchema.required(
    "errors.reusoProceso.volumenTanque.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3" } }),
  aprovechamiento: CantidadSchema.required(
    "errors.reusoProceso.aprovechamiento.required",
  )
    .test(
      "max",
      "errors.reusoProceso.aprovechamiento.test",
      (value) => (value && value.magnitud <= 100) || !value,
    )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "PORCENTAJE" } }),
});
